import * as React from "react";
import {UIState} from "data/UIState";

export const PlatformLoading = () =>
  <>
    <p>Loading</p>
  </>
;
